import { loginRegister } from './login-register-en.i18n';

export const en = {
  loginRegister,
};
